/* HTML-escape for user-entered and source-derived text interpolated into
   innerHTML templates (designs/projects-page.md D14). Escaping quotes too
   keeps attribute positions (value="…", data-name="…") safe. */
const REPLACEMENT: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export const esc = (text: string): string =>
  text.replace(/[&<>"']/g, (c) => REPLACEMENT[c] as string);
